var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMcSymbol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M11.192 2.177h9.453v15.617h-9.453z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M12.165 9.986a9.956 9.956 0 0 1 3.75-7.807A9.738 9.738 0 0 0 2.635 3.25c-3.473 3.805-3.473 9.67 0 13.475a9.738 9.738 0 0 0 13.28 1.07 9.956 9.956 0 0 1-3.75-7.809z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M30.951 16.527v-.64h.2v-.133h-.476v.133h.188v.64h.088zm.924 0v-.773h-.144l-.168.552-.168-.552h-.144v.773h.104v-.585l.156.502h.108l.156-.502v.585h.1zM31.802 9.986c0 3.803-2.147 7.271-5.528 8.933a9.727 9.727 0 0 1-10.359-1.126 9.973 9.973 0 0 0 3.752-7.808 9.973 9.973 0 0 0-3.752-7.808 9.727 9.727 0 0 1 10.36-1.126c3.38 1.662 5.527 5.13 5.527 8.932v.003z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcSymbol);
export default __webpack_public_path__ + "static/media/mc-symbol.d638d8a7d4f7097b80d36b8f3f054c11.svg";
export { ForwardRef as ReactComponent };